import type { Option } from '@ksyos/design-system';
import { AsyncSelect, FormGroup } from '@ksyos/design-system';
import { translateKey } from '@frontend/translate';
import type { IFetchResult } from '../../../store/fetch';
import { fetchJson } from '../../../store/fetch';

interface IPayoutRecordProviderGroupSelectionProps {
    error?: string;
    onChange: (value: string | null) => Promise<void> | void;
    onDoValidate: (value: string | null) => Promise<void> | void;
}

export function PayoutRecordProviderGroupSelection({
    onChange,
    onDoValidate,
    error,
}: IPayoutRecordProviderGroupSelectionProps) {
    return (
        <FormGroup
            hasErrors={!!error}
            label={translateKey('groups.group')}
        >
            <AsyncSelect
                cacheOptions
                defaultOptions
                error={error}
                isClearable
                loadOptions={getOptions}
                onChange={(selectedOption) => {
                    handleChange(selectedOption?.value || null);
                }}
            />
        </FormGroup>
    );

    async function getOptions(input: string): Promise<Option[]> {
        const url = `/api/payments/payoutRecordProviderGroup${input ? `?searchText=${input}` : ''}`;
        const result = (await fetchJson(url, 'GET')) as IFetchResult<{ items: { providerGroup: string }[] }>;

        if (result.json?.items) {
            return result.json.items.map(({ providerGroup }) => {
                return {
                    value: providerGroup,
                    label: providerGroup,
                };
            });
        }

        return [];
    }

    async function handleChange(value: string | null) {
        await onChange(value);
        await onDoValidate(value);
    }
}
